import { reqGetMAActivityTypeCacheCOList } from "../request/mtdsbase/internal/cache/getMAActivityTypeCacheCOList/post.js";
import { ref } from "vue-demi";
const activityList = ref(null);
function getActivityTypeSync() {
  if (!activityList.value) {
    activityList.value = [];
    reqGetMAActivityTypeCacheCOList({ productType: "\u5B9A\u5236\u54C1" }).then((r) => {
      activityList.value = r;
    });
  }
  return activityList;
}
function getActivityTypeLabel(code) {
  var _a;
  const list = getActivityTypeSync();
  const find = (_a = list.value) == null ? void 0 : _a.find((v) => v.value === code);
  return find ? find.label : code;
}
export { getActivityTypeLabel };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getActivityLabel.js